export const environment = {
  production: true,
  apiUrl: 'https://api.imastermin.com/api',
  keycloak: {
    url: 'https://auth.imastermin.com',
    realm: 'beautymatch',
    clientId: 'beautymatch-frontend'
  },
  analytics: {
    enabled: true,
    scriptUrl: 'https://analytics.imastermin.com/script.js',
    websiteId: '06a5a189-17bc-47ce-9b6d-18803f05105d'
  }
};
